import {TYPES} from './requirements-assessment-action-type.constants';
import {IDS} from './requirements-assessment-action-id.constants';
import * as TABS from '../../../common/tabs/tabs.constants';
import {TabsReducer} from '../../../common/tabs/tabs.reducer';
import * as FORM from '../../../common/form/input/input.constants';
import {GridReducer} from '../../../common/grid/grid.reducer';
import {GridFilterReducer} from '../../../common/grid/filter/grid-filter.reducer';
import * as GRID from '../../../common/grid/grid.constants';
import get from 'lodash/get';
import set from 'lodash/set';
import merge from 'lodash/merge';
import pick from 'lodash/pick';
import {getDocFileNameFromPath} from "../../../common/utils/util.path";

/**
 * @function RequirementsAssessmentReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function RequirementsAssessmentReducer(state, action) {

    if (typeof state === 'undefined') {
        const currentYear = new Date().getFullYear();
        return {
            auditors: [],
            reviewers: [],
            evidenceRequestStatusTypes: [
                {label:'Pending', value:'pen'},
                {label:'Completed', value:'cpl'}
            ],
            assignee: {
                autocompleteCandidates: [],
                autocompleteSelectedItem: null,
                firstName: null,
                lastName: null,
                email: null,
            },
            evidenceDetails: {
                name: null,
                doc_num: null,
                doc_type: null,
                filePath: null,
                reviewAssignee: null,
                reviewComment: null,
            },
            documentDetails: {
                name: null,
                doc_num: null,
                doc_type: null,
                doc_new_version: null,
                doc_url: null,
            },
            selectedEvidenceOwner : null,
            [IDS.rcoEvidenceGroupsProgressGrid]: GridReducer(),
            [IDS.rcoEvidenceGroupDocumentsGrid]: {...GridReducer(),
                filter: { limit: null },
            },
            [IDS.rcoEvidenceGroupHistoryGrid]: GridReducer(),
            [IDS.rcoEvidenceGroupImprovementStepsGrid]: {...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    limit: 100,
                    path: IDS.rcoEvidenceGroupImprovementStepsGrid,
                }},

            documentForRevisionRequest: null,
            docRevisionRequest: {},
            improvementAction: {},
            improvementStep: {},
            stepDialog: {},
            alsoAssignImprovementAction: {},
            documentAdd: {
                gridFilterRadioButtons: [
                    {value: 'ado',  label: 'Accreditation Documents'},
                    {value: '',     label: 'All Documents'}
                ],
            },
            // documentTypes: [
            //     { value: 'gdo', label: 'Generic Doc.' },
            //     { value: 'pol', label: 'Policy' },
            //     { value: 'pro', label: 'Procedure' },
            //     { value: 'coa', label: 'Contracts/Agreements' },
            //     { value: 'for', label: 'Form' },
            //     { value: 'che', label: 'Checklist' },
            // ],
        }
    }

    function refreshDocsGridRowStatusAndColor(items, selectedAuditTask) {
        items = items.map(item => {
            item = { ...item,
                $$hashKey: undefined
            }
            const auditorStatus = item.assessments.find(assessment => assessment.audit_task === selectedAuditTask)?.status_code
            switch(true) {
                case auditorStatus === 'app':
                    item.class = 'rcoDocumentApproved';
                    item.status = 'Approved';
                    item.status_code = 'app';
                    break;
                case auditorStatus === 'nap' && item.doc_revision_task_status_code === 'cpl':
                    item.class = 'rcoDocumentRevised';
                    item.status = 'Waiting for approval';
                    item.status_code = 'pen';
                    break;
                case auditorStatus === 'nap':
                    item.class = 'rcoDocumentReturned';
                    item.status = 'Waiting for revision';
                    item.status_code = 'nap';
                    break;
                default:
                    item.class = 'rcoDocumentPending';
                    item.status = 'Pending';
                    item.status_code = 'pen';
            }
            return item;
        })
        return [...items];
    }

    switch (action.type) {
        case TYPES.RESET_SELECTED_EVIDENCE_OWNER:
            return set({...state}, 'selectedEvidenceOwner', null)
        case TYPES.SAVE_UPLOADED_DOCUMENT:
            if (action.id === IDS.rcoRequirementsAssessment) {
                return {...state,
                    documentDetails: {
                        ...state.documentDetails,
                        doc_id:   action.doc_id,
                        doc_url:  action.filePath,
                        filename: getDocFileNameFromPath(action.filePath)
                    }
                }
            }

        case TYPES.SELECT_EVIDENCE_DETAILS:
            let details = action.item || get(state, `${IDS.rcoEvidenceGroupsProgressGrid}.items`, []).find(item => item.ard_id === action.ardId);
            details.doc_type = details.doc_type_code || action.firstDocType;
            state = set ({...state}, 'evidenceDetails', details);
            return set (state, 'documentDetails', {...details});

        case TYPES.FETCH_SITE_LOCATION_DETAILS:
            if (action.id === IDS.rcoRequirementsAssessment) {
                state = set({...state}, 'selectedSiteLocation.uuid',  action.locationUuid);
                set(    state,  'selectedSiteLocation.locationName',  action.locationName);
                set(    state,  'autocompleteAuditors',               action.autocompleteAuditors);
                return  set(    state,  'fiscalYearStart',            action.fiscalYearStart);
            }
        case TYPES.FETCH_HEAD_OFFICE_DETAILS:
            if (action.id === IDS.rcoRequirementsAssessment) {
                state = set({...state}, 'selectedSiteLocation.uuid', null);
                set(state, 'selectedSiteLocation.locationName', null);
                set(state, 'selectedHeadOffice.uuid', action.data.uuid);
                return set(state, 'selectedHeadOffice.name', action.data.name);
            }
        case TYPES.RESET_SELECTED_AUDIT_TASK:
            return set({...state}, 'selectedAuditTask', null);
        case TYPES.FETCH_AUDITOR_STATUSES:
            state = set({...state}, 'auditors', action.auditorStatuses);
            if(action.auditorStatuses.length) {
                set(state,
                    'selectedAuditTask',
                    action.auditorStatuses.find(item => item.assignee_uuid === action.userUuid)?.uta_id
                    || action.auditorStatuses[0].uta_id
                );
            }
            return set(state, 'auditorsSelectOptions', action.auditorStatuses.map(item => ({
                label: item.assignee,
                value: item.uta_id
            })));

        case TYPES.FETCH_REVIEW_TASKS:
            return set({...state}, 'reviewers', action.reviewTasks)
        case TYPES.SET_DOCUMENT_FOR_REVISION_REQUEST:
            return set({...state}, 'documentForRevisionRequest', action.item)
        case TYPES.SET_DOC_REVISION_REQUEST_DETAILS:
            state = set({...state}, 'docRevisionRequest', action.details);
            return set(state, 'alsoAssignImprovementAction', false);
        case TYPES.SET_IMPROVEMENT_ACTION_DETAILS:
            return set({...state}, 'improvementAction', action.details);
        case TYPES.SET_IMPROVEMENT_STEP_DETAILS:
            return set({...state}, 'improvementStep', action.details);
        case TYPES.UPDATE_IMPROVEMENT_STEP:
            // insert dialog object in to grid items
            state = set({...state},
                `${IDS.rcoEvidenceGroupImprovementStepsGrid}.items[${state.stepDialog.id}]`,
                get(state, `improvementStepDialog`));
            // refresh grid
            set(state, IDS.rcoEvidenceGroupImprovementStepsGrid,
                GridReducer( get(state, IDS.rcoEvidenceGroupImprovementStepsGrid), {
                    type: GRID.GRID_FETCH,
                    items: get(state, `${IDS.rcoEvidenceGroupImprovementStepsGrid}.items`, []),
                })
            );
        /* GENERIC TYPES */

        case 'LOCATION_SELECTED':
            if(action.id === IDS.rcoRequirementsAssessment) { // slo select-cascade
                return set({...state}, 'selectedSiteLocation', action)
            }
        case 'AUTOCOMPLETE_SELECTED':
            if (action.id === IDS.rcoRequirementsAssessment) {
                // if(!action.item)
                //     return state;
                return set({...state}, action.path, action.item);
            }
        case FORM.INPUT_SELECT:
        case FORM.INPUT_TEXT:
        case FORM.INPUT_CHECKBOX:
        case FORM.INPUT_DATE:
        case FORM.INPUT_RADIO:
        case 'INPUT_EMAIL_CHANGE':
        case 'INPUT_PHONE_CHANGE':
        case 'INPUT_TEXT_AREA_CHANGE':
        case 'INPUT_SIGNATURE':
            if (action.id !== IDS.rcoRequirementsAssessment) {
                return state;
            }
            // if(action.path.startsWith(IDS.documentAddGrid)) {
            //     const filter = {
            //         [action.path.split('.').pop()]: action.input
            //     };
            //     action.path = IDS.documentAddGrid;
            //     return set({...state}, action.path,
            //         GridReducer(get(state, action.path), { type: GRID.GRID_FILTER, filter })
            //     )
            // }
            state = set({...state}, action.path, action.input);
            if(action.path === 'selectedAuditTask') {
                set(state, IDS.rcoEvidenceGroupDocumentsGrid,
                    GridReducer( get(state, IDS.rcoEvidenceGroupDocumentsGrid),{
                        type: GRID.GRID_FETCH,
                        items: refreshDocsGridRowStatusAndColor(
                            get(state, `${IDS.rcoEvidenceGroupDocumentsGrid}.items`, []),
                            get(state, 'selectedAuditTask')
                )}));
            }
            return state;
        case GRID.GRID_INIT:
        case GRID.GRID_FILTER:
        case GRID.GRID_FILTER_TOGGLE:
        case GRID.GRID_RESET_FILTER:
        case GRID.GRID_INIT_FILTER:
        case GRID.GRID_LOADING:
        case GRID.GRID_PAGINATE:
        case GRID.GRID_RELOAD:
        case GRID.GRID_FETCH:
        case GRID.GRID_SELECT:
        case GRID.GRID_SELECT_ALL:
        case GRID.GRID_DESELECT:
        case GRID.GRID_DESELECT_ALL:
            if (action.id === IDS.rcoRequirementsAssessment) {
                if (action.type === GRID.GRID_FETCH && action.path === IDS.rcoEvidenceGroupDocumentsGrid) {
                    action.items = refreshDocsGridRowStatusAndColor( action.items, get(state, 'selectedAuditTask'));
                }
                return set({...state}, action.path, GridReducer( get(state, action.path), action))
            }
        case GRID.GRID_RESET:
            if (action.id === IDS.rcoRequirementsAssessment) {
                return set({...state}, action.path,
                    GridReducer( get(state, action.path),{
                        type: GRID.GRID_RESET_FILTER,
                        exclude: action.exclude /*|| (action.path === IDS.documentAddGrid ? ['slo_uuid','doc_type_code','assignedDocIds'] : [])*/,
                    })
                )
            }
        default:
            return state;
    }
}

const index = (children, list = []) => {
    children && children.forEach(item => {
        if(item) {
            list[parseInt(item.id)] = item;
            index(item.children, list);
        }
    })
    return list;
};
